import { createInstance, type Client } from '@optimizely/optimizely-sdk';
import AppConfig from '@/AppConfig';

export function createOptimizelyFeatureFlags(): Client | null {
  const datafileUrl = AppConfig.getOptimizelyDatafileUrl();

  return createInstance({
    sdkKey: AppConfig.getOptimizelySdkKey(),
    datafileOptions: {
      autoUpdate: false,
      ...(datafileUrl && { urlTemplate: datafileUrl }),
    },
  });
}

export const optimizelyFeatureFlags = createOptimizelyFeatureFlags();
